export const API_BASE_URL = '';
export const USER_ID = 'user_login_id';
export const DEALERSHIP_ID = 'dealership_id';
export const DEALERSHIP_DOC_ID = 'dealership_doc_id';
export const USER_LOGIN = 'user_login';